import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="py-24 px-4 bg-botanical-forest text-botanical-ivory relative overflow-hidden" data-id="element-171">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="border border-botanical-gold/30 p-8 md:p-16 rounded-sm bg-botanical-forest-dark/50 backdrop-blur-sm" data-id="element-173">
          <h2 className="text-3xl md:text-5xl font-playfair text-botanical-gold mb-8 italic" data-id="element-174">
            La Prueba del Tacto
          </h2>
          <p className="text-xl md:text-2xl font-lora leading-relaxed text-botanical-ivory/90" data-id="element-175">
            "A diferencia de los cosméticos tradicionales, las sales y óleos
            botánicos cambian la textura de tu piel desde la primera aplicación.
            No es una promesa a 30 días; es suavidad real que puedes sentir bajo
            tus dedos esta misma noche."
          </p>
        </motion.div>
      </div>
    </section>;
}